import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Row, Col, DatePicker, Form, Input, Select, Button } from 'antd';
import { IoIosArrowForward } from 'react-icons/io';
import { Config } from '../../../Config';
import { useGlobalState } from '../../../store/state';
import CreditBankDetailsComponent from '../Wallet/CreditBankDetailsComponent';
import { validatorGSTIN, validatorPAN } from '../../../utils';

const { Item } = Form;
const { Option } = Select;
const { TextArea } = Input;
const ProfileWalletComponent = ({ setCurrentTab, updateProfile }) => {
  const [user] = useGlobalState('user');
  const [formSettings, setFormSettings]= useState({
    cities: [],
  });

  useEffect(()=>{
    // note: get city list (local file)
    // fetch('/data/cityList.json')
    // .then(res => res.json())
    // .then((response)=>{
    //     setFormSettings({
    //         ...formSettings,
    //         cities:response[Config.country || 'India']
    //     })
    // })
  }, []);
  // function dobPickLimit(current) {
  //     // Min age need to be 18
  //     return current && current > moment().subtract(18, 'years');
  //   }

  const onBillingDetailsUpdate = (formData) =>{
    let _data ={};
    for (const [key, value] of Object.entries(formData)) {
      if (value) {
        _data ={
          ..._data,
          [key]: value,
        };
      }
      if (key === 'gstin' || key === 'businessName') {
        _data = {
          ..._data,
          gst: {
            ..._data.gst,
            [key]: value,
          },
        };
      }
      delete _data.gstin;
      delete _data.businessName;
    }
    // console.log("GST",_data)
    // note: send data to update
    updateProfile(_data);
  };
  return (
    <div className="prof_widget_basics">
      <div className="row flex-row-reverse">
        <div className="col-md-6 pl-md-2">
          <div style={{ height: '190px', paddingLeft: '15px' }}>
            <CreditBankDetailsComponent/>
          </div>
        </div>
        <div className="col-md-6 pr-md-2">
          <div className={`common_card p-3`}>
            <h6 className="pb-2">Update Billing Details</h6>
            <Form
              onFinish={onBillingDetailsUpdate}
              className="profile_basics_form"
              name="profileBillingForm"
              layout="vertical"
              requiredMark={false}
              initialValues={{
                'gstin': user.gst.gstin || undefined,
                'businessName': user.gst.businessName || undefined,
                'pan': user.pan || undefined,
              }}
            >
              <Item
                label="GSTIN (Optional)"
                name="gstin"
                rules={[
                  // {required:true,message: "This field can't be empty"},
                  {
                    validator: (_, value)=>{
                      if (value && !validatorGSTIN(value)) {
                        return Promise.reject(new Error('Not a valid GSTIN code'));
                      } else {
                        return Promise.resolve();
                      }
                    },
                  },
                ]}
              >
                <Input className="common_input"
                  size="large"
                  placeholder="Your Business GSTIN CODE"/>
              </Item>
              <Item
                label="Business Name (Optional)"
                name="businessName"
                // rules={[
                //     {required:true,message: "This field can't be empty"},
                // ]}
              >
                <Input className="common_input"
                  size="large"
                  placeholder="Provide business name"/>
              </Item>
              <Item
                label="PAN"
                name="pan"
                rules={[
                  { required: true, message: 'This field can\'t be empty' },
                  {
                    validator: (_, value)=>{
                      if (value && !validatorPAN(value)) {
                        return Promise.reject(new Error('Not a valid PAN'));
                      } else {
                        return Promise.resolve();
                      }
                    },
                  },
                ]}
              >
                <Input placeholder="Your Business PAN"
                  size="large"
                  className="common_input"/>
              </Item>

              <Item>
                <Button htmlType="submit"
                  className="common_button outlined mt-3 w-100">Update Billing Details</Button>
              </Item>
              <div className="py-1"></div>
            </Form>
          </div>
        </div>
      </div>
      {/* <Form
                name="profileBasicForm"
                layout="vertical"
                requiredMark={false}
            >
                <div className="row">
                    <div className="col-md-5 align-self-center">
                        <Row gutter={15} align="middle">
                            <Col>
                                <div className="prof_widget_basics--avatar">
                                    <img src={user.profilepicture} className="img-fluid" alt={user.fullname} />
                                </div>
                            </Col>
                            <Col>
                                <h4 className="prof_widget_basics--title mb-0">Hello <span>{user.fullname}</span></h4>
                                <p>We can't wait to know you more</p>
                            </Col>
                        </Row>
                    </div>
                    <div className="col-md-7">
                        <Item
                            label="Bio"
                            name="bio"
                        >
                            <TextArea rows={6} className="common_input" placeholder="Your Detailed Bio"/>
                        </Item>
                    </div>
                    <div className="col-md-3">
                        <Item
                            label="First Name"
                            name="firstname"
                            initialValue={user.firstname}
                            rules={[{required:true, message: "first name can't be empty"}]}
                        >
                            <Input type="text" size="large" className="common_input" placeholder="your first name"/>
                        </Item>
                    </div>
                    <div className="col-md-3">
                        <Item
                            label="Last Name"
                            name="lastname"
                            initialValue={user.lastname}
                            rules={[{required:true, message: "last name can't be empty"}]}
                        >
                            <Input type="text" size="large" className="common_input" placeholder="your last name"/>
                        </Item>
                    </div>
                    <div className="col-md-3">
                        <Item
                            label="Email ID"
                            name="email"
                            initialValue={user.email}
                            rules={[{required:true, message: "Email can't be empty"}]}
                        >
                            <Input type="email" size="large" disabled className="common_input" placeholder="your Email ID"/>
                        </Item>
                    </div>
                    <div className="col-md-3">
                        <Item
                            label="Phone number"
                            name="phone"
                            initialValue={user.phone}
                            rules={[{required:true, message: "Email can't be empty"}]}
                        >
                            <Input type="number" size="large" disabled className="common_input" placeholder="your Email ID"/>
                        </Item>
                    </div>

                    <div className="col-md-3">
                        <Item
                            label="Date of Birth"
                            name="dob"
                            initialValue={user.dob || undefined}
                        >
                            <DatePicker size="large" className="common_input" style={{width:"100%"}}
                                format={'Do MMM YYYY'}
                                disabledDate={dobPickLimit}
                                placeholder="Select your DOB"/>
                        </Item>
                    </div>
                    <div className="col-md-3">
                        <Item
                            label="Gender"
                            name="gender"
                            initialValue={user.gender || undefined}
                        >
                            <Select size="large" className="common_select" placeholder="Select your Gender">
                                <Option value="male">Male</Option>
                                <Option value="female">Female</Option>
                                <Option value="other">Other</Option>
                            </Select>
                        </Item>
                    </div>
                    <div className="col-md-3">
                        <Item
                            label="Country"
                            name="country"
                            initialValue={Config.country || 'India'}
                        >
                            <Select size="large" disabled className="common_select" placeholder="Select your Country">
                                <Option value={Config.country}>{Config.country}</Option>
                            </Select>
                        </Item>
                    </div>
                    <div className="col-md-3">
                        <Item
                            label="city"
                            name="city"
                            initialValue={user.city || undefined}
                        >
                            <Select size="large" className="common_select" placeholder="Select your City">
                                {   formSettings.cities.length ?

                                    formSettings.cities.map((city) =>(
                                        <Option key={city}>{city}</Option>
                                    ))
                                    :null
                                }
                            </Select>
                        </Item>
                    </div>
                    <div className="col-md-12 text-right">
                        <span>
                            <Button htmlType="submit" className="common_button outlined">Save</Button>
                        </span>
                        <span className="ml-3">
                            <Button className="common_button outlined" onClick={() => setCurrentTab('1')}>Platforms <IoIosArrowForward className="ml-2"/></Button>
                        </span>
                    </div>
                </div>
            </Form> */}
    </div>
  );
};

export default ProfileWalletComponent;
